import { render } from "./ExportStudy.vue?vue&type=template&id=3a3c43fa&scoped=true"
import script from "./ExportStudy.vue?vue&type=script&lang=js"
export * from "./ExportStudy.vue?vue&type=script&lang=js"

import "./ExportStudy.vue?vue&type=style&index=0&id=3a3c43fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3c43fa"]])

export default __exports__